// extracted by css-extract-rspack-plugin
export default {"switch":"ngAVrNhB","disabled":"x4numrxk","input":"kDW5AJJe","track":"EbUyrwC3","thumb":"Fc39CVy8","checked":"Eu0PvEEA","thumbIcon":"C4Q_o4NQ"};